// import debounce from 'debounce';
import select from 'dom-select';

export const CardDeck = (el) => {
  const ui = {
    el,
    body: select('body', document),
    detailsElement: select('.card-deck__utility .details', el),
    detailsSummary: select('.card-deck__utility .summary span', el),
  };

  const windowThreshold = 1024;

  const handleResize = () => {
    if (ui.detailsElement) {
      if (window.innerWidth >= windowThreshold) {
        ui.detailsElement.setAttribute('open', true);
      } else {
        ui.detailsElement.removeAttribute('open');
      }
    }
  }

  const addEvents = () => {

    window.addEventListener('resize', () => {
      handleResize();
    });
  }

  const init = () => {
    addEvents();
    handleResize();
  };

  init();
};

export default CardDeck;
